import { useState } from "react";
import FrontEndImage from "../../assets/img/logos/front-end.png";
import FullStackImage from "../../assets/img/logos/full-stack.png";
import BlockChainImage from "../../assets/img/logos/block-chain.png";
import DataAnalystImage from "../../assets/img/logos/data-analyst.png";
import CloudImage from "../../assets/img/logos/cloud.png";
import AIImage from "../../assets/img/logos/ai.png";
import IOTImage from "../../assets/img/logos/iot.png";
import CyberSecurityImage from "../../assets/img/logos/cyber-security.png";
import JSImage from "../../assets/img/logos/js.png";
import JavaImage from "../../assets/img/logos/java.png";
import AngularImage from "../../assets/img/logos/angular.png";
import PythonImage from "../../assets/img/logos/python.png";
import DotNetImage from "../../assets/img/logos/dot-net.png";
import ReactImage from "../../assets/img/logos/react.png";
import SqlImage from "../../assets/img/logos/sql.png";
import PhpImage from "../../assets/img/logos/php.png";
import { Tabs, Tab, Box, FormControl, InputLabel, Select, MenuItem, Button } from "@mui/material";
import "./TechnologyComponent.css";

import CategoryTechnology1 from "../../assets/CategoryTechnology1.json";
import CategoryTechnology2 from "../../assets/CategoryTechnology2.json";

type ImageMapKey =
  | "FrontEndImage"
  | "FullStackImage"
  | "BlockChainImage"
  | "DataAnalystImage"
  | "CloudImage"
  | "AIImage"
  | "IOTImage"
  | "CyberSecurityImage"
  | "JSImage"
  | "JavaImage"
  | "AngularImage"
  | "PythonImage"
  | "DotNetImage"
  | "PhpImage"
  | "ReactImage"
  | "SqlImage";


type CandidateItem = {
  title: string;
  candidates: number;
  image: ImageMapKey;
  alt: string;
};

const imageMap: Record<ImageMapKey, string> = {
  FrontEndImage,
  FullStackImage,
  BlockChainImage,
  DataAnalystImage,
  CloudImage,
  AIImage,
  IOTImage,
  CyberSecurityImage,
  JSImage,
  JavaImage,
  AngularImage,
  PythonImage,
  DotNetImage,
  PhpImage,
  ReactImage,
  SqlImage
};
const candidatesData: CandidateItem[] = [/* ... */];

const TechnologyComponent = () => {
    const [tabIndex, setTabIndex] = useState(0);

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setTabIndex(newValue);
    };
    return (
        
        <section className="md">
            <div className="container">
                <div className="text-center">
                    <h2 className="section-title">Trending Technologies/ Categories </h2>
                    <p className="section-info">
                        The top, in-demand tech categories and emerging technologies evaluated through IamInterviewed, reflecting the latest trends shaping today’s hiring landscape.</p>
                </div>
                <div className="card-body">
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs value={tabIndex} onChange={handleTabChange} aria-label="Categories tabs" centered>
                            <Tab label="Categories" />
                            <Tab label="Technology" />
                        </Tabs>
                    </Box>
                    <Box sx={{ mt: 2 }}>
                        {tabIndex === 0 && (
                            <div className="section5-tabpane">
                                {(CategoryTechnology1 as CandidateItem[]).map((item, idx) => (
                                    <div className="services-block-two" key={idx}>
                                        <div className="inner-box">
                                            <div className="icon-box-image">
                                                <img src={imageMap[item.image]} alt={item.alt} />
                                            </div>
                                            <h3>{item.title}</h3>
                                            <p>{item.candidates} Candidates</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                        {tabIndex === 1 && (
                            <div className="section5-tabpane">
                                {(CategoryTechnology2 as CandidateItem[]).map((item, idx) => (
                                    <div className="services-block-two" key={idx}>
                                        <div className="inner-box">
                                            <div className="icon-box-image">
                                                <img src={imageMap[item.image]} alt={item.alt} />
                                            </div>
                                            <h3>{item.title}</h3>
                                            <p>{item.candidates} Candidates</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </Box>
                </div>
            </div>
        </section>
       
    );
};
export default TechnologyComponent;